import { render, staticRenderFns } from "./invoices.vue?vue&type=template&id=76fba9ca&scoped=true&"
import script from "./invoices.vue?vue&type=script&setup=true&lang=js&"
export * from "./invoices.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./invoices.vue?vue&type=style&index=0&id=76fba9ca&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76fba9ca",
  null
  
)

export default component.exports